export default __webpack_public_path__ + "static/media/landingicon.436b1e5a.svg";